import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";
import { selectLaraThemeConfig } from "./components/select.config";
import { dataTableLaraThemeConfig } from "./components/datatable.config";
import { radioButtonLaraThemeConfig } from "./components/radiobutton.config";
import { inputLaraThemeConfig } from "./components/inputtext.config";
import { sliderLaraThemeConfig } from "./components/slider.config";
import { buttonConfig } from "./components/button.config";
import { iconFieldLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/icon-field.config";
import { checkboxLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/checkbox.config";
import { multiSelectLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/multiselect.config";
import { treeLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/tree.config";
import { breadCrumbLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/bread-crumb.config";
import { popoverLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/popover.config";
import { tabsLaraThemeConfig } from "@shared-core/config/primeng/themes/lara/components/tabs.config";
import { textareaConfig } from "@shared-core/config/primeng/themes/lara/components/textarea.config";
import { drawerConfig } from "@shared-core/config/primeng/themes/lara/components/drawer.config";
import { datepickerConfig } from "@shared-core/config/primeng/themes/lara/components/datepicker.config";
import { selectButtonConfig } from "@shared-core/config/primeng/themes/lara/components/select-button.config";

export const laraTheme = definePreset(Lara, {
  primitive: {
    gray: {
      25: "#FDFDFD",
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#E9EAEB",
      300: "#D5D7DA",
      400: "#A4A7AE",
      500: "#717680",
      600: "#535862",
      700: "#414651",
      800: "#252B37",
      900: "#181D27",
      950: "#0A0D12",
    },
    red: {
      50: "#FEF3F2",
      100: "#FEE4E2",
      200: "#FECDCA",
      300: "#FDA29B",
      400: "#F97066",
      500: "#F04438",
      600: "#D92D20",
      700: "#B42318",
      800: "#912018",
      900: "#7A271A",
      950: "#55160C",
    },
    green: {
      50: "#ECFDF3",
      100: "#DCFAE6",
      200: "#A9EFC5",
      300: "#75E0A7",
      400: "#47CD89",
      500: "#17B26A",
      600: "#079455",
      700: "#067647",
      800: "#085D3A",
      900: "#074D31",
      950: "#053321",
    },
    yellow: {
      50: "#FFFAEB",
      100: "#FEF0C7",
      200: "#FEDF89",
      300: "#FEC84B",
      400: "#FDB022",
      500: "#F79009",
      600: "#DC6803",
      700: "#B54708",
      800: "#93370D",
      900: "#7A2E0E",
      950: "#4E1D09",
    },
    purple: {
      50: "#F0F4F9",
      100: "#E0E9F2",
      200: "#C1D3E5",
      300: "#A2BDD8",
      400: "#83A7CB",
      500: "#6E93BF",
      600: "#5C80B2",
      700: "#4D6C97",
      800: "#3E577A",
      900: "#314562",
      950: "#1F2C3E",
    },
  },
  semantic: {
    primary: {
      0: "{purple.0}",
      50: "{purple.50}",
      100: "{purple.100}",
      200: "{purple.200}",
      300: "{purple.300}",
      400: "{purple.400}",
      500: "{purple.500}",
      600: "{purple.600}",
      700: "{purple.700}",
      800: "{purple.800}",
      900: "{purple.900}",
      950: "{purple.950}",
    },
    colorScheme: {
      light: {
        primary: {
          activeColor: "{primary.800}",
          color: "{primary.600}",
          hoverColor: "{primary.700}",
        },
      },
    },
    formField: {
      sm: {
        fontSize: "var(--font-size-text-16)",
        paddingY: "7px",
        paddingX: "11px",
      },
      extend: {
        sm: {
          lineHeight: "var(--line-height-text-24)",
        },
      },
    },
  },
  components: {
    iconfield: iconFieldLaraThemeConfig,
    radiobutton: radioButtonLaraThemeConfig,
    checkbox: checkboxLaraThemeConfig,
    datatable: dataTableLaraThemeConfig,
    select: selectLaraThemeConfig,
    multiselect: multiSelectLaraThemeConfig,
    tree: treeLaraThemeConfig,
    inputtext: inputLaraThemeConfig,
    slider: sliderLaraThemeConfig,
    button: buttonConfig,
    breadcrumb: breadCrumbLaraThemeConfig,
    popover: popoverLaraThemeConfig,
    tabs: tabsLaraThemeConfig,
    textarea: textareaConfig,
    drawer: drawerConfig,
    datepicker: datepickerConfig,
    selectbutton: selectButtonConfig,
  },
});
